module.exports = __webpack_public_path__ + "img/7.05108ec4.jpg";